import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import '../styles/Gallery.css';
import videoBackgroundDesktop from '../img/background/backgroundDesktop.mp4';
import videoBackgroundMobile from '../img/background/backgroundMobile.mp4';

const Gallery = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    document.body.classList.add('gallery-active');
    
    return () => {
      document.body.classList.remove('gallery-active');
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className={`gallery-wrapper ${videoLoaded ? 'video-loaded' : ''}`}>
      <video
        className="gallery-background-video"
        src={isMobile ? videoBackgroundMobile : videoBackgroundDesktop}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        onCanPlayThrough={() => setVideoLoaded(true)}
      ></video>
      
      <div className="gallery-container">
        <div className="gallery-item">
          <span className="small-italic-title">Photography</span>
        </div>
        <div className="gallery-item">
          <Link to="/advertising" className="combined-link">            
            <span className="large-link">ADVERTISING</span>
            <span className="small-italic-gallery">(1)</span>
          </Link>
        </div>
        <div className="gallery-item">
          <Link to="/portraits" className="combined-link">            
            <span className="large-link">PORTRAITS</span>
            <span className="small-italic-gallery">(2)</span>
          </Link>
        </div>
        <div className="gallery-item">
          <Link to="/documentary" className="combined-link">            
            <span className="large-link">DE BARRIOS</span>
            <span className="small-italic-gallery">(3)</span>
          </Link>
        </div>
        <div className="gallery-item">
          <Link to="/tasty" className="combined-link">            
            <span className="large-link">TASTY</span>
            <span className="small-italic-gallery">(4)</span>
          </Link>
        </div>
        <div className="gallery-item">
          <Link to="/studio" className="combined-link">
            <span className="large-link">STUDIO</span>
            <span className="small-italic-gallery">(5)</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
